// Planning module constants and configuration

export const API_URL = process.env.REACT_APP_BACKEND_URL;

export const courseTypes = [
  { value: 'collectif', label: 'Cours collectif' },
  { value: 'particulier', label: 'Cours particulier' },
  { value: 'stage', label: 'Stage' },
  { value: 'balade', label: 'Balade / Compétition' },
];

export const recurrenceTypes = [
  { value: 'unique', label: 'Unique' },
  { value: 'hebdomadaire', label: 'Hebdomadaire' },
];

// Duration options in hours for regular courses
export const durationHoursOptions = [
  { value: 30, label: '30 min' },
  { value: 45, label: '45 min' },
  { value: 60, label: '1h' },
  { value: 90, label: '1h30' },
  { value: 120, label: '2h' },
];

// Duration options in days for stages
export const durationDaysOptions = [
  { value: 0.5, label: 'Demi-journée', minutes: 240 },
  { value: 1, label: '1 jour', minutes: 480 },
  { value: 2, label: '2 jours', minutes: 960 },
  { value: 3, label: '3 jours', minutes: 1440 },
  { value: 4, label: '4 jours', minutes: 1920 },
  { value: 5, label: '5 jours', minutes: 2400 },
];

// Galop levels
export const galopLevels = [
  { value: 1, label: 'Galop 1' },
  { value: 2, label: 'Galop 2' },
  { value: 3, label: 'Galop 3' },
  { value: 4, label: 'Galop 4' },
  { value: 5, label: 'Galop 5' },
  { value: 6, label: 'Galop 6' },
  { value: 7, label: 'Galop 7' },
];

// Age categories
export const ageCategories = [
  { value: 'baby', label: 'Baby (3-5 ans)' },
  { value: 'poney', label: 'Poney (6-10 ans)' },
  { value: 'junior', label: 'Junior (11-17 ans)' },
  { value: 'adulte', label: 'Adulte (18+)' },
];

// Default new course template
export const getDefaultNewCours = () => ({
  theme_id: '',
  type_cours: 'collectif',
  instructeur_id: '',
  date_heure_debut: '',
  duree_minutes: 60,
  recurrence: 'unique',
  groupe_fixe_id: null,
  places_max: 6,
  lieu: '',
  notes: '',
  niveau_galop: '',
  categorie_age: ''
});
